import usePageTitleData from "../UseData/usePageTitleData";

export const getPageTitles = (
  crumbs: { pathname: string; crumbLabel: string }[]
) => {
  const data = usePageTitleData();
  const filteredCrumbs = crumbs.filter((crumb) => crumb.crumbLabel !== "se");

  const modifiedCrumbs = filteredCrumbs.map((crumb) => {
    const pageTitle = data.find((page) => page.slug === crumb.crumbLabel);
    return { ...crumb, crumbLabel: pageTitle?.title || crumb.crumbLabel };
  });

  return modifiedCrumbs;
};
